
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Auf den ersten Blick ja – und zwar ziemlich klischeehaft: Männer träumen mehr von Sex, Kampf und Waffen, Frauen hingegen häufiger von Kleidern und expliziten Gefühlen. `}<M mdxType="M">{`Typisch auch: Männer träumen gern von Männern. Zwei Drittel der Personen in ihren Träumen sind männlich,`}</M>{` bei Frauen ist das Geschlechterverhältnis ausgeglichen. Festgefahrene Rollenbilder schwingen natürlich auch in Träumen mit.`}<br /><br />{`
Betrachtet man die Sache genauer, lassen sich die Unterschiede weitgehend mit dem Alltagsverhalten begründen. «Männer haben öfter am Tag sexuelle Fantasien, und sie masturbieren häufiger als Frauen», sagt der deutsche Psychologe Michael Schredl. Was nachts in unserem Hirn passiert, hängt weniger vom Geschlecht ab als vom tagsüber Erlebten. «Wir konnten zum Beispiel belegen, dass Frauen häufiger von Männern träumen, wenn sie mehr Zeit mit männlichen Arbeitskollegen oder Freunden verbringen», so Schredl. Er selbst habe seine Träume auf diese Frage hin während seiner Zeit als Psychologiestudent analysiert: «Knapp die Hälfte meines Traumpersonals war weiblich, weil ich täglich mehr Studentinnen als Studenten zu Gesicht bekam.»`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;